import { MemberGroupDetail } from '../../../components/MemberGroup';

export function MemberGroup() {
  return <MemberGroupDetail />;
}
